import { createBrowserRouter, createRoutesFromElements, Route, useRouteError } from 'react-router';
import { RoutingErrorHandler } from '@livefree/react-ui';
import { Layout } from '@/routing/Layout';
import { Error } from '@/features/error';
import { Router as ProfileRouter } from '@/features/profile/Router';
import { Router as LoginRouter } from '@/features/login/Router';
import { Router as PasswordRouter } from '@/features/password/Router';
import { Router as LogoutRouter } from '@/features/logout/Router';

export const Router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      path="/*"
      element={<Layout />}
      errorElement={<RoutingErrorHandler useRouteError={useRouteError} />}
    >
      <Route index element={<ProfileRouter />} />
      <Route path="login/*" element={<LoginRouter />} />
      <Route path="logout/*" element={<LogoutRouter />} />
      <Route path="password/*" element={<PasswordRouter />} />
      <Route path="error/*" element={<Error />} />
    </Route>,
  ),
  { basename: '/' },
);
